module.exports = __webpack_public_path__ + "img/Service-symbol.e9fea75c.svg";